import messages from '../LinkBankAccount.messages';
import _ from 'lodash';

// eslint-disable-next-line import/no-default-export
export default (values) => {
    let errors = {};

    if (!validateIBAN(values)) {
        errors = _.setWith(errors, 'iban', messages.invalidIBAN);
    }

    if (!values.directDebitMandate) {
        errors = _.setWith(
            errors,
            'directDebitMandate',
            messages.mandateRequired
        );
    }

    return errors;
};

const validateIBAN = ({ iban }) => {
    if (!iban) {
        return;
    }
    const formattedIBAN = iban.toUpperCase().replace(/[^A-Z0-9]/g, '');
    const IBANFragments = formattedIBAN.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
    const countryCodeLengths = {
        DE: 22,
        GB: 22
    };
    let digits;

    const invalidCountryCode =
        !IBANFragments ||
        formattedIBAN.length !== countryCodeLengths[IBANFragments[1]];

    if (invalidCountryCode) {
        return false;
    }

    digits = (IBANFragments[3] + IBANFragments[1] + IBANFragments[2]).replace(
        /[A-Z]/g,
        (letter) => {
            return letter.charCodeAt(0) - 55;
        }
    );

    function mod97(digits) {
        let checksum = digits.slice(0, 2);
        let fragment;

        for (let offset = 2; offset < digits.length; offset += 7) {
            fragment = String(checksum) + digits.substring(offset, offset + 7);
            checksum = parseInt(fragment, 10) % 97;
        }

        return checksum;
    }

    return mod97(digits) === 1;
};
